import * as F from './flags'

export type CountryType = {
  label: string
  prefix: number
  iso: string
  flag: () => JSX.Element
}

export const COUNTRIES_PREFIX: Record<string, CountryType> = {
  GERMANY: { label: 'Germany', prefix: 49, iso: 'DE', flag: F.DE },
  AUSTRIA: { label: 'Austria', prefix: 43, iso: 'AT', flag: F.AT },
  BELGIUM: { label: 'Belgium', prefix: 32, iso: 'BE', flag: F.BE },
  DENMARK: { label: 'Denmark', prefix: 45, iso: 'DK', flag: F.DK },
  FRANCE: { label: 'France', prefix: 33, iso: 'FR', flag: F.FR },
  NETHERLANDS: { label: 'Netherlands', prefix: 31, iso: 'NL', flag: F.NL },
  ITALY: { label: 'Italy', prefix: 39, iso: 'IT', flag: F.IT },
  LUXEMBOURG: { label: 'Luxembourg', prefix: 352, iso: 'LU', flag: F.LU }
}
